import { render, staticRenderFns } from "./EntryPage.vue?vue&type=template&id=99bc0a5c&"
import script from "./EntryPage.vue?vue&type=script&lang=js&"
export * from "./EntryPage.vue?vue&type=script&lang=js&"
import style0 from "./EntryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports